import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigService } from '../core/services/config.service';

@Injectable({
  providedIn: 'root'
})
export class ReviewCrawledDataService {

  constructor(private http: HttpClient,
    private configService: ConfigService) { }

  getAPI =  "/api/getrvwdcrlddtalst";
  clientMasterOptionsAPI =  "/api/gtclntopts";

  Get(pagination: any) {
    return this.http.post(this.getAPI, pagination);
  }

  GetClientMasterOptions() {
    return this.http.post(this.clientMasterOptionsAPI, null);
  }
}

